import { twMerge } from "tailwind-merge";
import { clsx } from "clsx";
import { forwardRef, type ButtonHTMLAttributes } from "react";

type Variant = "primary" | "secondary" | "danger" | "ghost";
type Size = "sm" | "md";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}

const VARIANT: Record<Variant, string> = {
  primary: "bg-accent text-white hover:bg-accent-hover",
  secondary: "bg-surface-elev border border-border text-text-primary hover:bg-surface",
  danger: "bg-danger text-white hover:bg-danger/90",
  ghost: "text-text-secondary hover:text-text-primary hover:bg-surface/60",
};

const SIZE: Record<Size, string> = {
  sm: "h-8 px-3 text-xs",
  md: "h-9 px-4 text-sm",
};

const Button = forwardRef<HTMLButtonElement, Props>(function Button(
  { variant = "primary", size = "md", className, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      className={twMerge(
        clsx(
          "inline-flex items-center justify-center rounded-md font-medium transition-colors",
          "disabled:cursor-not-allowed disabled:opacity-50",
          VARIANT[variant],
          SIZE[size],
        ),
        className,
      )}
      {...rest}
    />
  );
});

export default Button;
